import React, { useState } from "react";
import { sendOtp } from "../services/eventService";
import { useNavigate } from "react-router-dom";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ loader state
  const navigate = useNavigate();

  const handleSendCode = async () => {
    if (!email || loading) return; // ✅ prevent multiple clicks

    try {
      setLoading(true); // ✅ start loader
      setSent(false);

      console.log(email);
      const res = await sendOtp(email);

      console.log(res);

      if (res?.status === 200) {
        if (res.data === "OTP sent successfully") {
          setSent(true);

          navigate("/verify-otp", {
            state: { email },
          });
        } else {
          alert(res.data);
        }
      } else {
        alert("Failed to send verification code");
      }

    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-6 flex flex-col items-center">

      {/* 🔹 Breadcrumb */}
      <div className="w-full max-w-4xl mb-4 text-xs">
        <span className="text-neutral-400">Home / </span>
        <span className="text-black">Delete Account</span>
      </div>

      {/* 🔹 Card */}
      <div className="w-full max-w-xl bg-white rounded-2xl shadow-lg border border-black/10 p-6 sm:p-8">

        {/* 🔹 Title */}
        <h2 className="text-2xl sm:text-3xl font-semibold text-center mb-6">
          Delete your account?
        </h2>

        {/* 🔹 Identity Verification */}
        <div className="text-center mb-6">
          <h3 className="text-lg sm:text-xl font-semibold text-neutral-700">
            Identity Verification
          </h3>
          <p className="text-sm sm:text-base text-zinc-600 mt-2 leading-relaxed">
            To proceed, we need to verify your ownership. We will send a 6-digit
            code to your registered email ID.
          </p>
        </div>

        {/* 🔹 Email Input */}
        <div className="mb-5">
          <label className="block text-sm font-medium mb-2">Email ID</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading} // ✅ optional: disable input while loading
            className="w-full h-12 px-4 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
          />
        </div>

        {/* 🔹 Button */}
        <button
          onClick={handleSendCode}
          disabled={loading} // ✅ prevent multiple clicks
          className="w-full h-12 bg-green-700 text-white rounded-lg font-semibold hover:bg-green-800 transition"
        >
          {loading ? "Sending..." : "Send Verification Code"}
        </button>

        {/* 🔹 Success Message */}
        {sent && !loading && (
          <p className="text-green-600 text-sm text-center mt-4">
            Verification code sent successfully!
          </p>
        )}
      </div>
    </div>
  );
};

export default DeleteAccount;